"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SCORE = exports.DEFAULT_STYLE = exports.BIAS_RANGE = exports.BIAS_COLORS = void 0;
var DEFAULT_STYLE = {
  SMALL: 'small',
  BG_COLOR: '#fafafa',
  TEXT_COLOR: 'greyDark',
  UNBIASED_COLOR: 'secondary',
  MIN_WIDTH_DESKTOP: '594px',
  MIN_WIDTH_MOBILE: '325px',
  SCORE_HEIGHT: '40px',
  SCORE_WIDTH: '40px',
  SCORE_LINE_HEIGHT: '40px'
};
exports.DEFAULT_STYLE = DEFAULT_STYLE;
var BIAS_COLORS = {
  DETRACTORS: 'primaryDark',
  NEUTRAL: 'yellow',
  PROMOTERS: 'tertiary'
};
exports.BIAS_COLORS = BIAS_COLORS;
var BIAS_RANGE = {
  DETRACTORS: 7,
  NEUTRAL: 9
};
exports.BIAS_RANGE = BIAS_RANGE;
var SCORE = {
  MIN: 0,
  MAX: 10
};
exports.SCORE = SCORE;